const searchUrlMap = {
  adultsCount: 'ac',
  childrenAges: 'ca',
  orderBy: 'o',
  selectedFlightVariantKeys: 'sf',
  selectedAirlines: 'sa',
  selectedAirports: 'sp',
  directionIndex: 'di',
  directOnly: 'do',
  showDetailsParams: 'd',
  multiModalDistributorParams: 'mm',
  serviceClass: 'sc',
  priceWithBaggage: 'b',
  selectedTime: 'st',
  showMultiModalVariants: 'smm',
  transfers: 'tr',
  flightsWithoutSelfChange: 'sch',
  // для передачи параметров на страницу оплаты
  routeKey: 'rk',
};

export default searchUrlMap;
